module.exports = __webpack_public_path__ + "static/img/stock-photo-new-home-construction-build-with-wooden-truss-post-and-beam-framework-797485732.31f8fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-new-home-construction-build-with-wooden-truss-post-and-beam-framework-797485732.jpg
// module id = qDHB
// module chunks = 1